import { useGlobalModal } from '@/global-hooks/use-global-modal';
import { Modal, Typography } from '@/shared/design-system';

export type RejectModalProps = { isLoading: boolean; onConfirm: () => void; type?: string };

export const RejectModal = () => {
  const { handleClose, open, props } = useGlobalModal('REJECT_ENTITY_AFFILIATION');

  return (
    <Modal
      open={open}
      onOpenChange={(next) => {
        if (!next) handleClose();
      }}
      title={`Reject ${props?.type ?? ''}`}
      maxWidth={516}
      primaryAction={{
        label: 'Reject',
        color: 'destructive',
        onClick: props?.onConfirm,
        disabled: props?.isLoading,
      }}
      secondaryAction={{ label: 'Go Back', onClick: handleClose }}
    >
      <Typography variant="body1">Are you sure you want to reject {props?.type}?</Typography>
    </Modal>
  );
};
